module.exports = __webpack_public_path__ + "img/Earn.683c19d8.jpg";